import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { DealerCarouselWrapper } from 'site-modules/dealerships/components/dealer-carousel-wrapper/dealer-carousel-wrapper';
import { CarouselTagsDescription } from 'site-modules/shared/components/carousel-tags-description/carousel-tags-description';

const initialState = {
  currentSlide: 0,
  category: 'DEFAULT',
};

export class DealerCarouselWithDescriptionUI extends Component {
  constructor(props) {
    super(props);
    this.state = initialState;
  }

  /**
   * Set up current slide number for getting slide description
   * @param from {number}
   * @param to {number}
   */
  setCurrentSlide = (from, to) => {
    this.setState({
      currentSlide: to,
    });
  };

  setCategory = category => {
    if (!category) return this.setState(initialState);
    return this.setState({
      category,
      currentSlide: 0,
    });
  };

  render() {
    const { dealerId, photosByCategory, slidesByCategory, tagList, isMobile } = this.props;
    const { category, currentSlide } = this.state;
    return (
      <div className="mb-1 mb-md-2">
        <DealerCarouselWrapper
          slides={slidesByCategory[category]}
          setCurrentSlide={this.setCurrentSlide}
          isMobile={isMobile}
          dealerId={dealerId}
        />
        <CarouselTagsDescription
          isMobile={isMobile}
          tagList={tagList}
          currentTag={category}
          description={photosByCategory[category][currentSlide].description}
          setTag={this.setCategory}
        />
      </div>
    );
  }
}

DealerCarouselWithDescriptionUI.propTypes = {
  dealerId: PropTypes.number,
  photosByCategory: PropTypes.shape({
    DEFAULT: PropTypes.arrayOf(PropTypes.object),
  }).isRequired,
  slidesByCategory: PropTypes.shape({
    DEFAULT: PropTypes.arrayOf(PropTypes.element),
  }).isRequired,
  tagList: PropTypes.arrayOf(PropTypes.string),
  isMobile: PropTypes.bool,
};

DealerCarouselWithDescriptionUI.defaultProps = {
  dealerId: null,
  tagList: [],
  isMobile: false,
};

export function mapStateToProps(state) {
  const isMobile = !!(state && state.mobile);

  return {
    isMobile,
  };
}
export const DealerCarouselWithDescription = connect(mapStateToProps)(DealerCarouselWithDescriptionUI);
